module.exports = __webpack_public_path__ + "static/media/magnifying-glass.12b64fec.svg";